import PropTypes from "prop-types"
import React from "react"

const ReservationBadges = ({ reservation }) => {
  const badges = []

  // Space Type Badge
  if (reservation.requested_space_type) {
    const isDoc = reservation.requested_space_type.toLowerCase() === "dock"
    badges.push(
      <span
        key="space-type"
        className={`label label-inline-block ${
          isDoc ? "badge-orange" : "badge-bg-blue"
        }`}
      >
        {reservation.requested_space_type.charAt(0).toUpperCase() +
          reservation.requested_space_type.slice(1)}
      </span>
    )
  }

  // Wide Beam Badge
  if (reservation.wide_beam) {
    badges.push(
      <span key="wide-beam" className="label label-inline-block label-warning">
        Wide Beam
      </span>
    )
  }

  // Special Request Badge
  if (reservation.special_request) {
    badges.push(
      <span
        key="special-request"
        className="label label-inline-block label-success"
      >
        Special Request
      </span>
    )
  }

  // Check-in Status Badges
  if (reservation.checked_in_not_out) {
    badges.push(
      <span
        key="checked-in"
        className="label label-inline-block badge-blue-inverted"
      >
        Checked In
      </span>
    )
  }

  if (reservation.checked_out) {
    badges.push(
      <span key="checked-out" className="label label-inline-block badge-gray">
        Checked Out
      </span>
    )
  }

  // Payment Status Badges
  if (reservation.unpaid_not_pending) {
    badges.push(
      <span key="unpaid" className="label label-inline-block label-danger">
        Unpaid
      </span>
    )
  } else if (reservation.add_card_later) {
    badges.push(
      <span
        key="missing-card"
        className="label label-inline-block label-warning"
      >
        Missing Card
      </span>
    )
  }

  // Communication Badge
  if (reservation.unread_boater_messages) {
    badges.push(
      <span
        key="unread-message"
        className="label label-inline-block label-danger"
      >
        Unread Message
      </span>
    )
  }

  // Manual Approval Badge
  if (reservation.contact_requires_manual_approval) {
    badges.push(
      <span
        key="manual-approval"
        className="label label-inline-block label-dark"
      >
        See Customer Note
      </span>
    )
  }

  return (
    <div
      className="flex flex-wrap items-center justify-start gap-1.5 py-2"
      style={{ fontSize: "1.1em" }}
    >
      {badges}
    </div>
  )
}

ReservationBadges.propTypes = {
  reservation: PropTypes.shape({
    belongs_to_contract: PropTypes.bool,
    contract_group_name: PropTypes.string,
    requested_space_type: PropTypes.string,
    wide_beam: PropTypes.bool,
    special_request: PropTypes.bool,
    checked_in_not_out: PropTypes.bool,
    checked_out: PropTypes.bool,
    unpaid_not_pending: PropTypes.bool,
    add_card_later: PropTypes.bool,
    unread_boater_messages: PropTypes.bool,
    contact_requires_manual_approval: PropTypes.bool,
  }).isRequired,
}

export default ReservationBadges
